import { Component, OnInit, ViewChild } from '@angular/core';
import { AgenciesService, GetAllAgenciesResult, UpdateAgentModel } from 'src/app/Api_Module';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'crg-agencies',
  templateUrl: './agencies.component.html'
})
export class AngenciesComponent implements OnInit {

  @ViewChild('angecyTable') table: DatatableComponent;
  
  searchStr: string;

  loadingAgents: boolean;
  loadingSearch: boolean;

  selectedAgecies: GetAllAgenciesResult[] = [];
  selectedVeh: UpdateAgentModel[] = [];
  selectedAgency: GetAllAgenciesResult;

  agencies: GetAllAgenciesResult[] = [];
  cache: GetAllAgenciesResult[] = [];

  agents: any[] = [];

  filtervalue: string;

  alert;

  messagesAgencies = { emptyMessage: 'No Angencies found. Try different parameters', totalMessage: 'Total Agencies' };

  messagesAgents = { emptyMessage: 'No Agent found. Try different parameters', totalMessage: 'Total Agents' };

  constructor(private agenciesService: AgenciesService, private toastr: ToastrService) { }

  ngOnInit() {
    this.searchAgencies();
  }

  searchAgencies() {
    this.agents = [];

    this.loadingSearch = true;
    this.agenciesService.getAgencies().subscribe((resp: GetAllAgenciesResult[]) => {
      this.loadingSearch = false;
      this.agencies = [...resp];
      this.cache = [...resp];
    },
      error => {
        this.loadingSearch = false;

        if (error['status'] === 404) {
          this.toastr.warning('Agency Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }

        console.log('error:' + JSON.stringify(error));
      });
  }

  onSelect(agencyObj: any) {
    this.loadingAgents = true;
    console.log(JSON.stringify(agencyObj));
    const agentId = agencyObj.selected[0].id;
    this.selectedAgency = agencyObj.selected[0];
    this.agents = [];
    this.agenciesService.getAgency(agentId).subscribe((resp: GetAllAgenciesResult) => {
      this.loadingAgents = false;
      this.agents = [...resp.agents];
    },
      error => {
        this.loadingAgents = false;
        if (error['status'] === 404) {
          this.toastr.warning('Agent(s) Not Found!');
        } else {
          this.toastr.error('Something went wrong please try again later!');
        }
        console.log('error:' + JSON.stringify(error));
      });
  }

  deleteAgency(agencyId) {
    this.loadingSearch = true;
    this.agenciesService.deleteAgency(agencyId).subscribe((resp: GetAllAgenciesResult) => {
      this.loadingAgents = false;
      this.toastr.success('Agency Deleted.');
      this.searchAgencies();
    },
      error => {
        this.loadingAgents = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
    this.loadingSearch = false;
  }

  deleteAgent(agentId) {
    this.loadingAgents = true;
    this.agenciesService.deleteAgent(agentId).subscribe((resp) => {
      this.loadingAgents = false;
      this.toastr.success('Agent Deleted.');
      this.searchAgencies();
    },
      error => {
        this.loadingAgents = false;
        this.toastr.error('Something went wrong please try again later!');
        console.log('error:' + JSON.stringify(error));
      });
   // this.toastr.warning('Not Impletement Yet');
    this.loadingAgents = false;
  }

  updateFilter(event) {
    const val = this.filtervalue;

    if (val) {
        // filter our data
        this.agents = [];
        this.selectedAgecies = [];
        this.selectedAgency = null;
    const temp = this.agencies.filter(function(d) {
      return (d.name && d.name.toLowerCase().indexOf(val) !== -1) || !val;
    });

    // update the rows
    this.agencies = temp;
    } else {
      this.agencies = [... this.cache];
    }
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  clearFilter() {
    this.filtervalue = '';
    this.agencies = [... this.cache];
  }


  close(alert: any) {
    this.alert = null;
  }
}
